import { render, staticRenderFns } from "./LoginComponent.vue?vue&type=template&id=4456fa11&scoped=true&"
import script from "./LoginComponent.vue?vue&type=script&lang=js&"
export * from "./LoginComponent.vue?vue&type=script&lang=js&"
import style0 from "./LoginComponent.vue?vue&type=style&index=0&id=4456fa11&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../igs3-fontend-prod353/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4456fa11",
  null
  
)

export default component.exports